<template>
        <!-- Features -->
    <div id="features" class="tabs">
        <div class="container" style="padding-bottom:2em;">
            <div class="row">
                <div class="col-lg-12">
                    <h2>WOODS</h2>
                    <div class="p-heading p-large">We are offering these Spell Trackers in the following woods</div>
                </div> <!-- end of col -->
            </div> <!-- end of row -->
            <div class="row">
                <!-- Tabs Links -->
                <ul class="nav nav-tabs" id="lenoTabs" role="tablist">
                    <li class="nav-item">
                        <div class="card card-body">
                            <img @click="chooseWood('maple')" v-bind:class="[wood == 'maple' ? 'active' : '']" class="wood-swatch" src="../assets/images/Maple Circle.png"/>
                            <span class="wood-text">Maple</span>
                        </div>
                   </li>
                   <li class="nav-item">
                        <div class="card card-body">
                            <img @click="chooseWood('cherry')" v-bind:class="[wood == 'cherry' ? 'active' : '']" class="wood-swatch" src="../assets/images/Cherry_Circle.png"/>
                            <span class="wood-text">Cherry</span>
                        </div>
                   </li>
                    <li class="nav-item">
                        <div class="card card-body">
                            <img @click="chooseWood('purpleHeart')" v-bind:class="[wood == 'purpleHeart' ? 'active' : '']" class="wood-swatch" src="../assets/images/Purple Heart Circle2.png"/>
                            <span class="wood-text">Purple Heart</span>
                        </div>
                    </li>
                    <li class="nav-item">
                        <div class="card card-body">
                            <img @click="chooseWood('blackWalnut')" v-bind:class="[wood == 'blackWalnut' ? 'active' : '']" class="wood-swatch" src="../assets/images/Black Walnut Circle.png"/>
                            <span class="wood-text">Black Walnut</span>
                        </div>
                    </li>
                    <li class="nav-item">
                        <div class="card card-body">
                            <img @click="chooseWood('padauk')" v-bind:class="[wood == 'padauk' ? 'active' : '']" class="wood-swatch" src="../assets/images/Padauk Circle.png"/>
                            <span class="wood-text">Padauk*</span>
                        </div>
                    </li>
                    <li class="nav-item">
                        <div class="card card-body">
                            <img @click="chooseWood('monkeyPod')" v-bind:class="[wood == 'monkeyPod' ? 'active' : '']" class="wood-swatch" src="../assets/images/Monkey Pod Circle.png"/>
                            <span class="wood-text">Monkey Pod*</span>
                        </div>
                    </li>
                </ul>
            </div> <!-- end of row --> 
            <div class="row">
                <div class="col-lg-12" style="font-style:italic;">* stretch goals</div>
            </div>
        </div> <!-- end of container --> 
        <img class="img-fluid" :src="woodUrl">
    </div> <!-- end of tabs -->
    <!-- end of features -->
</template>

<script>

export default {
  name: 'WoodsPage',
  data() {
      return {
        wood: 'maple',
        woodUrl: require('../assets/images/Wood_Banner_Maple.png')
      }
  },
  methods: {
    chooseWood (wood) {
        this.wood = wood
        if (wood=='maple')
            this.woodUrl = require('../assets/images/Wood_Banner_Maple.png')
        else if (wood=='purpleHeart')
            this.woodUrl = require('../assets/images/Wood_Banner_PurpleHeart.png')
        else if (wood=='blackWalnut')
            this.woodUrl = require('../assets/images/Wood_Banner_BlackWalnut.png')
        else if (wood=='padauk')
            this.woodUrl = require('../assets/images/Wood_Banner_Padauk.png')
        else if (wood=='monkeyPod')
            this.woodUrl = require('../assets/images/Wood_Banner_MonkeyPod.png')
        else if (wood=='cherry')
            this.woodUrl = require('../assets/images/Wood_Banner_Cherry.png')
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Woods.vue